export const fullPageReload = () => {
  window?.location?.reload?.();
};

export const fullPageReloadWithDelay = (delay: number = 1000) => {
  setTimeout(() => {
    fullPageReload();
  }, delay);
};
